import React from 'react';

import { Control } from 'react-hook-form';
import { InputAdornment } from '@mui/material';

import { LbInput, InputView } from '@infoods/lifebase-ui';

import { FeeTermsFormValues } from '../../../interfaces/feeTerms';
import { Mode } from '../../../../general-types';
import { getIsNullish } from '../../../../shared/utils/jsUtils';

type SaasTaxInputProps = {
  mode: Mode;
  control: Control<FeeTermsFormValues>;
  saasTax: number;
};

const SaasTaxInput = ({ mode, control, saasTax }: SaasTaxInputProps) => {
  if (mode === 'VIEW') {
    const inputValue = getIsNullish(saasTax) ? 'Not set' : `${saasTax} %`;

    return (
      <InputView valueClassName="private-info" value={inputValue} label="Sales Tax" />
    );
  }

  return (
    <LbInput
      variant="outlined"
      control={control}
      name="saasTax"
      type="number"
      size="small"
      rules={{
        required: 'SaaS Tax is required',
        min: { value: 0, message: 'Saas tax should be in range: 0 - 100' },
        max: { value: 100, message: 'Saas tax should be in range: 0 - 100' },
      }}
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      }}
    />
  );
};

export { SaasTaxInput };
